import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChange } from "../../../pages/generalReducer/action/GlobalAction";
import { CryptoJSAesEncrypt } from "../../../api/encryption";
import { postData } from "../../../api/api";
import Swal from "sweetalert2";
import MainpageHook from "../../../pages/HomePage/hooks/MainpageHook";

const NavHook = () => {
  const reducer_data = useSelector((state) => state.GlobalReducer);
  const { ...loading } = MainpageHook();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };
  const handleClick = (item) => {
    setIsDrawerOpen(false);
    loading.handleLoading(item.route);
  };

  const onChangeText = (e, objectKey) => {
    let name = e.target.name;
    let value = e.target.value;
    dispatch(
      handleChange({
        [objectKey]: {
          ...reducer_data[objectKey],
          [name]: value,
        },
      })
    );
    console.log(reducer_data);
  };

  const handleSubmit = async (e) => {
    handleDialogClose();
    setIsDrawerOpen(false);

    e.preventDefault();
    const { inquiry } = reducer_data;
    const hasEmptyField = Object.values(inquiry).some((value) => !value.trim());

    if (hasEmptyField) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please fill in all required fields.",
      });
      return;
    }
    try {
      const formData = new FormData();
      const { inquirer_name, inquirer_email, inquirer_message } =
        reducer_data.inquiry;
      // let data = {
      //   inquirer_name,
      //   inquirer_email,
      //   inquirer_message,
      // };
      // Append all fields to formData
      let data = {};
      for (const [key, value] of Object.entries(inquiry)) {
        data[key] = value;
        formData.append(key, value);
      }

      formData.append("data", CryptoJSAesEncrypt(JSON.stringify(data)));
      postData("inquiry/", formData).then((res) => {
        if (res.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Your inquiry is submitted successfully!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred. Please check your input.",
          });
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred. Please try again later.",
      });
    }
  };

  return {
    onChangeText,
    handleDialogOpen,
    handleDialogClose,
    isDialogOpen,
    handleSubmit,
    isDrawerOpen,
    handleDrawerClose,
    handleDrawerOpen,
    handleClick,
  };
};

export default NavHook;
